import http from '../../utils/fetch';
export default {

    baseurl:'/api/swyl/v1/demo/bscClueOwner',
    baseurlDesign:'/api/swyl/v1/demo/bscDesignClueOwner',
    baseurlCompany:'/api/swyl/v1/demo/bscClueCompanyOwner',
    baseurlIndustry:'/api/swyl/v1/demo/bscClueIndustryOwner',



    selectById(query){
        return http({
            url: this.baseurl + '/selectById',
            method: 'post',
            params: query
        });
    },

    updateById(query){
        return http({
            url: this.baseurl + '/updateById',
            method: 'post',
            params: query
        });
    },
    deleteById(query){
        return http({
            url: this.baseurl + '/deleteById',
            method: 'post',
            params: query
        });
    },



    restoreRun(query){
        return http({
            url: this.baseurl + '/restoreRun',
            method: 'post',
            params: query
        });

    },

    sendMsg(){
        return http.post(this.baseurl + '/sendMsg');
    },
    querySmsSendDetail(){
        return http.post(this.baseurl + '/querySmsSendDetail');
    },


    getwlzhaobiao(query){

        return http({
            url: this.baseurl+'/getwlzhaobiao',
            method: 'post',
            params: query
        });

    },


    selectPage(query){
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            params: query
        });
    },


    insert(query){
        return http({
            url: this.baseurl + '/insert',
            method: 'post',
            params: query
        });
    },

    selectClueOwner(query){
        return http({
            url: this.baseurl+'/selectClueOwner',
            method: 'post',
            params: query
        });
    },

/*****************************baseurlDesign**************************/

    designSelectPage(query){
        return http({
            url: this.baseurlDesign + '/selectPage',
            method: 'post',
            params: query
        });
    },

    designInsert(query){
        return http({
            url: this.baseurlDesign + '/insert',
            method: 'post',
            params: query
        });
    },
    designSelectById(query){
        return http({
            url: this.baseurlDesign + '/selectById',
            method: 'post',
            params: query
        });
    },

    designUpdateById(query){
        return http({
            url: this.baseurlDesign + '/updateById',
            method: 'post',
            params: query
        });
    },
    designDeleteById(query){
        return http({
            url: this.baseurlDesign + '/deleteById',
            method: 'post',
            params: query
        });
    },


    /*****************************baseurlCompany**************************/

    companySelectPage(query){
        return http({
            url: this.baseurlCompany + '/selectPage',
            method: 'post',
            params: query
        });
    },

    companyInsert(query){
        return http({
            url: this.baseurlCompany + '/insert',
            method: 'post',
            params: query
        });
    },

    companyUpdateById(query){
        return http({
            url: this.baseurlCompany + '/updateById',
            method: 'post',
            params: query
        });
    },
    companyDeleteById(query){
        return http({
            url: this.baseurlCompany + '/deleteById',
            method: 'post',
            params: query
        });
    },


    /*****************************baseurlIndustry**************************/


    industrySelectPage(query){
        return http({
            url: this.baseurlIndustry + '/selectPage',
            method: 'post',
            params: query
        });
    },

    industryInsert(query){
        return http({
            url: this.baseurlIndustry + '/insert',
            method: 'post',
            params: query
        });
    },

    industryUpdateById(query){
        return http({
            url: this.baseurlIndustry + '/updateById',
            method: 'post',
            params: query
        });
    },
    industryDeleteById(query){
        return http({
            url: this.baseurlIndustry + '/deleteById',
            method: 'post',
            params: query
        });
    },





}
